import moment from 'moment';
import { addDays, format } from 'date-fns';
export default {
  props: {
    reassignmentType: {
      type: String,
      default: 'TEMPORARY'
    }
  },
  data() {
    return {
      startDate: '',
      startTime: '',
      endDate: '',
      endTime: ''
    };
  },
  computed: {
    startDateMin() {
      return moment().startOf('day').toDate();
    },
    todayLocalStr() {
      return moment().format('YYYY-MM-DD');
    },
    nowTimeStr() {
      return moment().format('HH:mm:ss');
    },
    startTimeMin() {
      return this.startDate === this.todayLocalStr ? this.nowTimeStr : null;
    },
    endDateMin() {
      return this.startDate ? moment(this.startDate, 'YYYY-MM-DD').toDate() : moment().startOf('day').toDate();
    },
    endTimeMin() {
      if (!this.endDate) {
        return null;
      }
      if (this.endDate === this.startDate && this.startTime) {
        const startMoment = moment(this.startTime, 'HH:mm:ss');
        const nextStep = startMoment.clone().add(15, 'minutes');
        return nextStep.isSame(startMoment, 'day') ? nextStep.format('HH:mm:ss') : '23:59:59';
      }
      if (this.endDate === this.todayLocalStr) {
        return this.nowTimeStr;
      }
      return null;
    }
  },
  watch: {
    startDate(val) {
      if (this.reassignmentType === 'TEMPORARY' && val && !this.endDate) {
        this.endDate = format(addDays(moment(val, 'YYYY-MM-DD').toDate(), 14), 'yyyy-MM-dd');
      }
      this.emitChange();
    },
    endDate() {
      this.emitChange();
    },
    reassignmentType() {
      this.endDate = '';
      this.endTime = '';
      this.emitChange();
    }
  },
  methods: {
    secsFromTimeStr(timeStr) {
      if (!timeStr) {
        return 0;
      }
      const [h, m] = timeStr.split(':');
      return Number(h) * 3600 + Number(m) * 60;
    },
    emitChange() {
      if (!this.startDate || !this.startTime) {
        this.$emit('change', {
          startTimestamp: null,
          endTimestamp: null
        });
        return;
      }
      const startTimestamp = moment(this.startDate, 'YYYY-MM-DD').unix() + this.secsFromTimeStr(this.startTime);
      let endTimestamp = null;
      if (this.reassignmentType === 'TEMPORARY' && this.endDate && this.endTime) {
        endTimestamp = moment(this.endDate, 'YYYY-MM-DD').unix() + this.secsFromTimeStr(this.endTime);
      }
      this.$emit('change', {
        startTimestamp,
        endTimestamp
      });
    }
  }
};